export const decompressPrefetchedData = (data: any, locale: string) => {
  // Handle locale found case, it's important that only primitives were compressed
  if (Object.keys(data).includes(locale)) {
    return data[locale];
  }

  // All of deep links will be updated
  const copy = { ...data };

  for (const key in data) {
    const value = data[key];

    if (Array.isArray(value)) {
      copy[key] = [];
      value.forEach((item, index) => {
        copy[key][index] = decompressPrefetchedData(item, locale);
      });
    } else if (typeof value === "object" && value !== null) {
      copy[key] = decompressPrefetchedData(value, locale);
    }

    // Primitives are skipped
  }

  return copy;
};
